export default __webpack_public_path__ + "assets/location-c8fc865e5c8cb89b9bfaf63feba358a8.svg";